"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;

var _stitches = require("../../stitches.config");

var StyledInput = (0, _stitches.styled)('input', {
  background: 'transparent',
  border: '0',
  color: '$inputText',
  flex: '1',
  fontSize: '$small',
  fontWeight: '$medium',
  lineHeight: '1',
  outline: '0',
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '16px',
  paddingRight: '16px',
  position: 'relative',
  '&::placeholder': {
    color: '$grey500',
    fontWeight: '$regular'
  }
});
exports.StyledInput = StyledInput;